<template>
  <div class="container">
    <div class="head-btns">
      <el-button
        class="mwow-button-filled primary"
        @click="handleExport"
        v-debounce="1000"
        >导出</el-button
      >
    </div>
    <common-search-form-wrapper :reset="handleSearchReset">
      <el-form size="mini" :model="searchInfo" inline>
        <el-row>
          <el-col :span="8">
            <el-form-item label="订单搜索:" prop="order_no">
              <el-input
                v-model="searchInfo.order_no"
                placeholder="请输入订单号"
                @change="handleSearch"
                clearable
                @clear="handleSearch"
                prefix-icon="el-icon-search"
                maxlength="120"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="学员姓名:" prop="student_key_word">
              <el-input
                v-model="searchInfo.student_key_word"
                placeholder="学员姓名/手机号"
                @change="handleSearch"
                clearable
                @clear="handleSearch"
                prefix-icon="el-icon-search"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="业务类型:" prop="order_type">
              <el-select
                v-model="searchInfo.order_type"
                placeholder="请选择"
                multiple
                @change="handleSearch('orderType')"
                clearable
              >
                <el-option
                  v-for="item in orderTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="业务形式:" prop="business_type">
              <el-select
                v-model="searchInfo.business_type"
                multiple
                placeholder="请选择"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in businessList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="审批状态:" prop="approval_status">
              <el-select
                v-model="searchInfo.approval_status"
                multiple
                placeholder="请选择"
                @change="handleSearch('approvalStatus')"
              >
                <el-option
                  v-for="item in approvalStatusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="购买内容:" prop="course_id">
              <el-select
                v-model="searchInfo.course_id"
                filterable
                clearable
                placeholder="请选择"
                :filter-method="handleSearchCourse"
                @change="handleSearch"
                @focus="handleSearchCourse('')"
              >
                <el-option
                  v-for="item in buyCourese"
                  :key="item.course_id"
                  :label="item.title"
                  :value="item.course_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="科目:" prop="subject_id" class="item6">
              <el-select
                v-model="searchInfo.subject_id"
                placeholder="请选择"
                @focus="getSubjectList"
                @change="handleSearch"
                clearable
              >
                <el-option
                  v-for="item in subjectsList"
                  :key="item.subject_id"
                  :label="item.subject_title"
                  :value="item.subject_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="创建人:" prop="create_staff_id" class="item7">
              <common-staff-pull-down
                :originId.sync="searchInfo.create_staff_id"
                :defaultSelected.sync="searchInfo.create_staff_list"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="业务人员:" prop="belong">
              <common-staff-pull-down
                :originId.sync="searchInfo.belong"
                :defaultSelected.sync="searchInfo.belong_list"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 创建时间不支持删除，默认过滤当年的订单，历史订单跨度不能超过一年 -->
            <el-form-item label="创建时间:" prop="create_date">
              <!-- <el-date-picker
                v-model="searchInfo.create_date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="handleSearch('create_date')"
                :clearable="false"
              >
              </el-date-picker> -->
              <common-date-range-selector
                v-model="searchInfo.create_date"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="handleSearch('create_date')"
                :clearable="false"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="支付时间: " prop="handle_time">
              <!-- <el-date-picker
                v-model="searchInfo.handle_time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="handleSearch('handle_time')"
              ></el-date-picker> -->
              <common-date-range-selector
                v-model="searchInfo.handle_time"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="handleSearch('handle_time')"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="退款时间:" prop="refund_time">
              <!-- <el-date-picker
                v-model="searchInfo.refund_time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="handleSearch('refund_time')"
              >
              </el-date-picker> -->
              <common-date-range-selector
                v-model="searchInfo.refund_time"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="handleSearch('refund_time')"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="订单状态:" prop="order_status">
              <el-radio-group
                v-model="searchInfo.order_status"
                @change="handleSearch('orderStatus')"
              >
                <el-radio-button :label="-1">全部</el-radio-button>
                <el-radio-button :label="1">待付款</el-radio-button>
                <el-radio-button :label="3">已付款</el-radio-button>
                <el-radio-button :label="4">已取消</el-radio-button>
                <el-radio-button :label="5">部分付款</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="实收/实退金额:">
              <div class="price-box">
                <el-input
                  v-model="searchInfo.completed_amount_start"
                  type="number"
                  placeholder="最低金额"
                  clearable
                  @input="
                    (v) => {
                      if (/\.\d{3}/.test(String(v))) {
                        searchInfo.completed_amount_start =
                          Number(v).toFixed(2);
                      }
                    }
                  "
                  @change="
                    () => {
                      if (searchInfo.completed_amount_start !== '') {
                        searchInfo.completed_amount_start = Math.abs(
                          Number(searchInfo.completed_amount_start)
                        ).toFixed(2);
                      }
                      handleSearch();
                    }
                  "
                ></el-input>
                <span style="margin: 0 5px">至</span>
                <el-input
                  v-model="searchInfo.completed_amount_end"
                  type="number"
                  placeholder="最高金额"
                  clearable
                  @input="
                    (v) => {
                      if (/\.\d{3}/.test(String(v))) {
                        searchInfo.completed_amount_end = Number(v).toFixed(2);
                      }
                    }
                  "
                  @change="
                    () => {
                      if (searchInfo.completed_amount_end !== '') {
                        searchInfo.completed_amount_end = Math.abs(
                          Number(searchInfo.completed_amount_end)
                        ).toFixed(2);
                      }
                      handleSearch();
                    }
                  "
                >
                </el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <div class="orderAmountBox">
      <div class="orderAmount">
        <div class="green">
          实收总计:
          {{
            (Math.round(Number(tatistics.income) * 100) -
              Math.round(Number(tatistics.expend) * 100)) /
            100
          }}
          元；
        </div>
        <div class="gray">收入总计:{{ tatistics.income || 0 }}元；</div>
        <div class="red">实退总计:{{ tatistics.expend || 0 }}元；</div>
        <el-popover
          placement="top"
          width="190"
          popper-class="followuppopover"
          trigger="hover"
        >
          <p class="tipck">
            收入总计 = 实收总计 -
            实退总计，实收总计不包含已废除订单和部分付款订单的收入金额，实退总计不包含部分付款订单的退款金额
          </p>
          <div class="question" slot="reference">
            <div>?</div>
          </div>
        </el-popover>
      </div>
    </div>
    <el-table
      size="mini"
      v-horizontal-scroll
      :data="tableData"
      stripe
      style="width: 100%"
      tooltip-effect="dark"
      @sort-change="clickSort"
      :default-sort="{
        order: 'descending',
        prop: 'create_time',
      }"
    >
      <el-table-column label="订单号" width="160">
        <template slot-scope="scope">
          <span class="ordernum green" @click="toDetail(scope.row.order_id)">{{
            scope.row.order_no
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="审批状态" prop="approval_status">
        <template slot-scope="scope">
          <span>{{ handleApprovalStatus(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="订单状态" prop="order_status">
        <template slot-scope="scope">
          <span>{{ handleOrderStatus(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="学员姓名">
        <template slot-scope="scope">{{
          scope.row.student.name || "-"
        }}</template>
      </el-table-column>
      <el-table-column label="业务类型" prop="item_type">
        <template slot-scope="scope">
          <span v-if="scope.row.order_type === 1">购课</span>
          <span v-if="scope.row.order_type === 2">退课</span>
          <span v-if="scope.row.order_type === 3">
            转课
            <span>{{
              scope.row.payment_type === 1 ? "[转入]" : "[转出]"
            }}</span>
          </span>
          <span v-if="scope.row.order_type === 4">购活动</span>
          <span v-if="scope.row.order_type === 5">退单</span>
        </template>
      </el-table-column>
      <el-table-column label="业务形式">
        <template slot-scope="scope">
          <span v-if="scope.row.order_type !== 3">
            <span v-if="scope.row.business_type === 1">新购</span>
            <span v-if="scope.row.business_type === 2">续费</span>
            <span v-if="scope.row.business_type === 3">拓科</span>
            <span v-if="scope.row.business_type === 0">-</span>
          </span>
          <span v-else> - </span>
        </template>
      </el-table-column>
      <el-table-column label="购买内容" prop="product_name" width="155">
      </el-table-column>
      <el-table-column label="内容价格" prop="spec_name">
        <template slot-scope="scope">
          <div v-if="scope.row.order_type === 4">{{ scope.row.amount }}</div>
          <div v-else>{{ scope.row.spec_name }}</div>
        </template>
      </el-table-column>
      <el-table-column label="购买数量" prop="scope" width="70">
        <template slot-scope="scope">
          <div v-if="scope.row.order_type === 4">1</div>
          <span v-else>{{ scope.row.quantity }}课时</span>
        </template>
      </el-table-column>
      <el-table-column label="赠送数量" prop="give_product_quantity" width="70">
        <template slot-scope="scope">
          <div v-if="scope.row.order_type === 4">-</div>
          <span v-else>{{ scope.row.give_product_quantity }}课时</span>
        </template>
      </el-table-column>
      <el-table-column label="直减" prop="discount_amount" width="100">
        <template slot-scope="scope">
          <span>{{
            scope.row.payment_type == 1
              ? Number(scope.row.discount_amount) == 0
                ? "-"
                : "￥" + scope.row.discount_amount
              : "-"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="手续费" prop="discount_amount" width="100">
        <template slot-scope="scope">
          <span>{{
            scope.row.payment_type == 2
              ? Number(scope.row.discount_amount) == 0
                ? "-"
                : "￥" + scope.row.discount_amount
              : "-"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="应收/应退"
        prop="receivable_amount"
        width="126"
        min-width="110"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.order_type === 4">-</div>
          <div v-else>
            <!-- 开通支付，并且是待支付状态，显示 - -->
            <div
              v-if="
                onlinePay &&
                scope.row.payment_type == 1 &&
                scope.row.payment_status === 1
              "
            >
              -
            </div>
            <div v-else>
              <div v-if="scope.row.payment_type == 1">
                <span class="moneyType">收</span>
                <span class="editBtn">￥{{ scope.row.receivable_amount }}</span>
              </div>
              <div v-if="scope.row.payment_type == 2">
                <span class="moneyType retreat">退</span>
                <span class="orderClose"
                  >￥{{ scope.row.receivable_amount }}</span
                >
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="实收/实退"
        prop="completed_amount"
        min-width="110"
      >
        <template slot-scope="scope">
          <!-- 开通支付，并且是待支付状态，显示 - -->
          <div
            v-if="
              onlinePay &&
              scope.row.payment_type == 1 &&
              scope.row.payment_status === 1
            "
          >
            -
          </div>
          <div v-else>
            <div v-if="scope.row.payment_type == 1">
              <span class="moneyType">收</span>
              <span class="editBtn">￥{{ scope.row.completed_amount }}</span>
            </div>
            <div v-if="scope.row.payment_type == 2">
              <span class="moneyType retreat">退</span>
              <span class="orderClose">￥{{ scope.row.completed_amount }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="创建人">
        <template slot-scope="scope">
          <div v-if="scope.row.order_type === 4">-</div>
          <!-- 创建人有时为 null -->
          <span v-else>{{ scope.row.create_staff.name }}</span>
        </template>
      </el-table-column>
      <!-- 活动订单 staff_id === 0 是官方 -->
      <el-table-column label="业务人员">
        <template slot-scope="scope">
          <div v-if="scope.row.belong_staff.length > 0">
            <span
              class="dot"
              v-for="(item, index) in scope.row.belong_staff"
              :key="index"
            >
              {{ item.name }}
            </span>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="create_time"
        width="140"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      ></el-table-column>
      <!-- <el-table-column
        label="支付时间"
        prop="handle_time"
        width="140"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      >
      </el-table-column> -->
      <el-table-column
        label="支付时间"
        prop="handle_time"
        width="140"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.payment_type === 1 ? scope.row.handle_time : "-"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="退款时间"
        prop="refund_time"
        width="140"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      >
        <template slot-scope="scope">
          <span>
            {{
              scope.row.payment_type === 2
                ? scope.row.payment_status === 2
                  ? "-"
                  : scope.row.handle_time
                : "-"
            }}
          </span>
          <!-- <span>
            {{ scope.row.payment_type === 2 ? scope.row.handle_time : "-" }}
          </span> -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>
<script>
import { orderitemListApi, orderItemStatisticsApi } from "@/api/order";
import { exportOrderItemListApi } from "@/api/export";
import { getSelectCourseList } from "@/api/globalSearch";
import { exportLoop } from "@/utils/export";
import { subjectList } from "@/api/subject";
import { dateFormat } from "@/utils/timeFormat";
import { PageModule } from "@/store/module/page";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import commonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";
import { UserModule } from "@/store/module/user";

export default {
  name: "orderLine",
  components: {
    commonSearchFormWrapper,
    commonStaffPullDown,
    commonDateRangeSelector,
  },
  props: ["visible"],
  data() {
    return {
      searchInfo: {
        order_type: [],
        handle_time: [],
        refund_time: [],
        // 默认过滤当年的订单，历史订单跨度不能超过一年
        create_date: [],
        business_type: [],
        course_id: "",
        sort_field: "create_time",
        sort_type: "desc",
        create_staff_list: [],
        create_staff_id: "",
        belong_list: [],
        belong: "",
        item_type: -1,
        approval_status: [],
        order_status: -1,
        completed_amount_start: "",
        completed_amount_end: "",
      },
      orderTypeList: [
        {
          value: 1,
          label: "购课",
        },
        {
          value: 2,
          label: "退课",
        },
        {
          value: 3,
          label: "转课",
        },
        {
          value: 4,
          label: "购活动",
        },
        {
          value: 5,
          label: "退单",
        },
      ],
      businessList: [
        {
          value: 1,
          label: "新购",
        },
        {
          value: 2,
          label: "续费",
        },
        {
          value: 3,
          label: "拓科",
        },
      ],
      approvalStatusList: [
        {
          value: 0,
          label: "无审批",
        },
        {
          value: 1,
          label: "审批中",
        },
        {
          value: 2,
          label: "已同意",
        },
        {
          value: 3,
          label: "已拒绝",
        },
        {
          value: 4,
          label: "已取消",
        },
      ],
      buyCourese: [],
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      tatistics: {},
      subjectsList: [],
      // 业务类型分为两大类，转课类型同时拥有订单状态和退款状态
      cache: {
        type1: [1, 4, 3],
        type2: [2, 5, 3],
        curType: 0, // 当前数据哪一大类
        lastData: "", // 获取的最新数据
      },
    };
  },
  created() {
    if (PageModule.latestRoute === "dashboard") {
      if (this.$route.query.tab === "orderline") {
        const params = this.$route.params;
        if (params.start_date && params.end_date) {
          this.searchInfo.handle_time = [params.start_date, params.end_date];
        }
        if (params.subject_id) {
          this.searchInfo.subject_id = Number(params.subject_id);
        }
        if (params.order_type_arr) {
          this.searchInfo.order_type = JSON.parse(params.order_type_arr);
        }
      }
    } else {
      const searchLineInfo = PageModule.pageInfo.financialOrderLine;
      if (searchLineInfo.search_info) {
        this.searchInfo = searchLineInfo.search_info;
      }
      if (searchLineInfo.page) {
        this.page = searchLineInfo.page;
      }
      if (searchLineInfo.page_size) {
        this.pageSize = searchLineInfo.page_size;
      }
      if (this.$route.query.tab === "orderline") {
        if (this.$route.query.cid) {
          this.searchInfo.course_id = Number(this.$route.query.cid);
        }
        if (this.$route.query.order_type) {
          // this.searchInfo.order_type = Number(this.$route.query.order_type);
          this.searchInfo.order_type = [1, 2, 3];
        }
        if (this.$route.query.start && this.$route.query.end) {
          this.searchInfo.handle_time = [
            this.$route.query.start,
            this.$route.query.end,
          ];
        }
      }
    }
    // 来自体验数据
    if (this.$route.query.from === "experienceToDetailed") {
      this.searchInfo.handle_time[0] = this.$route.query.s_time;
      this.searchInfo.handle_time[1] = this.$route.query.e_time;
      if (this.$route.query.source_id) {
        this.searchInfo.course_id = Number(this.$route.query.source_id);
      }
    }
    this.getNowYear();
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.handleSearch();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.handleSearch();
    }
  },
  // 监听变化
  watch: {
    "cache.curType": {
      handler(n, o) {
        // 如果新旧不一致，并且不是初始时，则重置 order_type为获取的最新数据
        if (n !== o && o !== 0) {
          this.searchInfo.order_type = [this.cache.lastData];
        }
        if (n === 1) {
          this.searchInfo.payment_type = 1;
        } else if (n === 2) {
          this.searchInfo.payment_type = 2;
        }
      },
      immediate: false,
      deep: false,
    },
  },
  computed: {
    onlinePay() {
      return UserModule.userInfo.online_pay;
    },
  },
  methods: {
    getSubjectList() {
      if (this.subjectsList.length > 0) {
        return false;
      }
      subjectList({
        page: 1,
        page_size: 100,
      }).then((res) => {
        this.subjectsList = res.data.list;
      });
    },
    // 默认获取一年的订单
    getNowYear() {
      let date = new Date();
      let now = Date.now();
      let yearTimestamp = 366 * 24 * 60 * 60 * 1000; // 一年的时间戳，需要再多一天（精准）
      let yearDate = new Date(now - yearTimestamp);

      let startYear = yearDate.getFullYear();
      let startMonth = String(yearDate.getMonth() + 1).padStart(2, "0");
      let startDay = String(yearDate.getDate()).padStart(2, "0");

      let endYear = date.getFullYear();
      let endMonth = String(date.getMonth() + 1).padStart(2, "0");
      let endDay = String(date.getDate()).padStart(2, "0");
      // 回显创建时间查询
      this.searchInfo.create_date = [
        `${startYear}-${startMonth}-${startDay}`,
        `${endYear}-${endMonth}-${endDay}`,
      ];
    },

    handleSearchReset() {
      this.searchInfo = {
        order_type: [],
        handle_time: [],
        refund_time: [],
        create_date: [],
        business_type: [],
        course_id: "",
        sort_field: "create_time",
        sort_type: "desc",
        create_staff_list: [],
        create_staff_id: "",
        belong_list: [],
        belong: "",
        item_type: -1,
        approval_status: [],
        order_status: -1,
      };
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
      this.getOrderTatistics();
    },
    getOrderTatistics() {
      const option = {};
      if (this.searchInfo.student_key_word) {
        option.student_key_word = this.searchInfo.student_key_word;
      }
      if (this.searchInfo.order_no) {
        option.order_no = this.searchInfo.order_no;
      }
      if (this.searchInfo.belong) {
        option.belong = this.searchInfo.belong;
      }
      if (this.searchInfo.create_date) {
        option.create_time_start = this.searchInfo.create_date[0];
        option.create_time_end = this.searchInfo.create_date[1];
      }
      if (this.searchInfo.handle_time) {
        option.handle_time_start = this.searchInfo.handle_time[0];
        option.handle_time_end = this.searchInfo.handle_time[1];
      }
      if (this.searchInfo.refund_time) {
        option.refund_time_start = this.searchInfo.refund_time[0];
        option.refund_time_end = this.searchInfo.refund_time[1];
      }
      if (this.searchInfo.order_type && this.searchInfo.order_type.length > 0) {
        option.order_type_arr = this.searchInfo.order_type;
      }
      if (this.searchInfo.business_type.length > 0) {
        option.business_type = this.searchInfo.business_type;
      }
      if (this.searchInfo.create_staff_id) {
        option.create_staff_id = this.searchInfo.create_staff_id;
      }
      if (this.searchInfo.course_id) {
        option.course_id = this.searchInfo.course_id;
      }
      if (this.searchInfo.subject_id) {
        option.subject_id = this.searchInfo.subject_id;
      }
      if (
        this.searchInfo.approval_status &&
        this.searchInfo.approval_status.length > 0
      ) {
        option.approval_status_arr = this.searchInfo.approval_status;
      }
      if (this.searchInfo.item_type > 0) {
        option.item_type = this.searchInfo.item_type;
      }
      // 购课订单状态
      if (this.searchInfo.order_status > 0) {
        option.payment_status = Number(this.searchInfo.order_status);
      }
      // 退款订单状态
      if (this.searchInfo.refund_status > 0) {
        option.payment_status = Number(this.searchInfo.refund_status);
      }
      if (this.searchInfo.completed_amount_start) {
        option.completed_amount_start = String(
          this.searchInfo.completed_amount_start
        );
      }
      if (this.searchInfo.completed_amount_end) {
        option.completed_amount_end = String(
          this.searchInfo.completed_amount_end
        );
      }
      orderItemStatisticsApi(option).then((res) => {
        if (res.error_code === 0) {
          res.data.expend = res.data.expend === "0.00" ? "0" : res.data.expend;
          res.data.income = res.data.income === "0.00" ? "0" : res.data.income;
          this.tatistics = res.data;
        }
      });
    },
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
        sort_field: this.searchInfo.sort_field,
        sort_type: this.searchInfo.sort_type,
      };
      if (this.searchInfo.order_no) {
        option.order_no = this.searchInfo.order_no;
      }
      if (this.searchInfo.order_type && this.searchInfo.order_type.length > 0) {
        option.order_type_arr = this.searchInfo.order_type;
      }
      if (this.searchInfo.student_key_word) {
        option.student_key_word = this.searchInfo.student_key_word;
      }
      if (this.searchInfo.create_staff_id) {
        option.create_staff_id = this.searchInfo.create_staff_id;
      }
      if (this.searchInfo.belong) {
        option.belong = this.searchInfo.belong;
      }
      if (this.searchInfo.course_id) {
        option.course_id = this.searchInfo.course_id;
      }
      if (this.searchInfo.create_date) {
        option.create_time_start = this.searchInfo.create_date[0];
        option.create_time_end = this.searchInfo.create_date[1];
      }
      if (this.searchInfo.handle_time) {
        option.handle_time_start = this.searchInfo.handle_time[0];
        option.handle_time_end = this.searchInfo.handle_time[1];
      }
      if (this.searchInfo.refund_time) {
        option.refund_time_start = this.searchInfo.refund_time[0];
        option.refund_time_end = this.searchInfo.refund_time[1];
      }
      if (this.searchInfo.subject_id) {
        option.subject_id = this.searchInfo.subject_id;
      }
      if (this.searchInfo.business_type) {
        option.business_type = this.searchInfo.business_type;
      }
      if (this.searchInfo.approval_status.length > 0) {
        option.approval_status_arr = this.searchInfo.approval_status;
      }
      if (this.searchInfo.item_type > 0) {
        option.item_type = this.searchInfo.item_type;
      }
      // 购课订单状态
      if (this.searchInfo.order_status > 0) {
        option.payment_status = Number(this.searchInfo.order_status);
      }
      // 退款订单状态
      if (this.searchInfo.refund_status > 0) {
        option.payment_status = Number(this.searchInfo.refund_status);
      }
      if (this.searchInfo.payment_type >= 0) {
        option.payment_type = Number(this.searchInfo.payment_type);
      }
      if (this.searchInfo.completed_amount_start) {
        option.completed_amount_start = String(
          this.searchInfo.completed_amount_start
        );
      }
      if (this.searchInfo.completed_amount_end) {
        option.completed_amount_end = String(
          this.searchInfo.completed_amount_end
        );
      }
      orderitemListApi(option).then((res) => {
        if (res.error_code === 0) {
          this.tableData = res.data.list;
          res.data.list.map((item) => {
            item.create_time = dateFormat(
              "YYYY-mm-dd HH:MM",
              new Date(item.create_time * 1000)
            );
            item.handle_time = item.handle_time
              ? dateFormat(
                  "YYYY-mm-dd HH:MM",
                  new Date(item.handle_time * 1000)
                )
              : "-";
          });
          this.total = res.data.total;
          this.page = params.page;
        }
      });
    },
    handleExport() {
      const option = {};
      if (this.searchInfo.order_no) {
        option.order_no = this.searchInfo.order_no;
      }
      if (this.searchInfo.order_type && this.searchInfo.order_type.length > 0) {
        option.order_type_arr = this.searchInfo.order_type;
      }
      if (this.searchInfo.student_key_word) {
        option.student_key_word = this.searchInfo.student_key_word;
      }
      if (this.searchInfo.create_staff_id) {
        option.create_staff_id = this.searchInfo.create_staff_id;
      }
      if (this.searchInfo.belong) {
        option.belong = this.searchInfo.belong;
      }
      if (this.searchInfo.course_id) {
        option.course_id = this.searchInfo.course_id;
      }
      if (this.searchInfo.create_date) {
        option.create_time_start = this.searchInfo.create_date[0];
        option.create_time_end = this.searchInfo.create_date[1];
      }
      if (this.searchInfo.handle_time) {
        option.handle_time_start = this.searchInfo.handle_time[0];
        option.handle_time_end = this.searchInfo.handle_time[1];
      }
      if (this.searchInfo.refund_time) {
        option.refund_time_start = this.searchInfo.refund_time[0];
        option.refund_time_end = this.searchInfo.refund_time[1];
      }
      if (this.searchInfo.subject_id) {
        option.subject_id = this.searchInfo.subject_id;
      }
      if (this.searchInfo.business_type) {
        option.business_type = this.searchInfo.business_type;
      }
      if (this.searchInfo.approval_status.length > 0) {
        option.approval_status_arr = this.searchInfo.approval_status;
      }
      if (this.searchInfo.item_type > 0) {
        option.item_type = this.searchInfo.item_type;
      }
      // 购课订单状态
      if (this.searchInfo.order_status > 0) {
        option.payment_status = Number(this.searchInfo.order_status);
      }
      // 退款订单状态
      if (this.searchInfo.refund_status > 0) {
        option.payment_status = Number(this.searchInfo.refund_status);
      }
      if (this.searchInfo.payment_type >= 0) {
        option.payment_type = Number(this.searchInfo.payment_type);
      }
      if (this.searchInfo.completed_amount_start) {
        option.completed_amount_start = String(
          this.searchInfo.completed_amount_start
        );
      }
      if (this.searchInfo.completed_amount_end) {
        option.completed_amount_end = String(
          this.searchInfo.completed_amount_end
        );
      }
      exportOrderItemListApi(option).then((res) => {
        if (res.error_code === 0) {
          exportLoop(res.data.task_id);
        }
      });
    },
    handleSearchCourse(v) {
      let page_size = 10;
      if (v == "") {
        page_size = 100;
      }
      getSelectCourseList({
        page: 1,
        page_size: page_size,
        title: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.buyCourese = res.data.list;
        }
      });
    },
    handleSearch(v) {
      // 过滤业务类型，只有购课和购活动能共存，其他只能独存
      if (v === "orderType") {
        // 业务类型分为两大类，转课类型同时拥有订单状态和退款状态
        // 获取最新类型
        this.cache.lastData =
          this.searchInfo.order_type[this.searchInfo.order_type.length - 1];
        // 转课 3 类型除外，转课类型同时拥有订单状态和退款状态
        if (this.cache.lastData !== 3) {
          if (this.cache.type1.includes(this.cache.lastData)) {
            this.cache.curType = 1;
          } else if (this.cache.type2.includes(this.cache.lastData)) {
            this.cache.curType = 2;
          }
        }
        // 业务类型清空时，重置条件
        if (this.searchInfo.order_type.length === 0) {
          this.searchInfo.payment_type = -1;
          this.searchInfo.handle_time = null;
          this.searchInfo.refund_time = null;
          this.searchInfo.order_status = -1;
        }
      }
      if (v === "handle_time") {
        if (this.searchInfo.order_type.length === 0) {
          // 异步处理，防止出现一闪而过的数据
          this.searchInfo.order_type = [];
          setTimeout(() => {
            this.searchInfo.order_type = this.cache.type1;
          }, 0);
        } else {
          // 当只有转课类型时，
          if (this.searchInfo.order_type.includes(3)) {
            // order_type 长度为 1 或包含 1、4时不做处理
            if (
              !(
                this.searchInfo.order_type.length === 1 ||
                this.searchInfo.order_type.includes(1) ||
                this.searchInfo.order_type.includes(4)
              )
            ) {
              // 其他情况重置
              this.searchInfo.order_type = [];
              setTimeout(() => {
                this.searchInfo.order_type = this.cache.type1;
              }, 0);
            }
          } else {
            if (
              !(
                this.searchInfo.order_type.includes(1) ||
                this.searchInfo.order_type.includes(4)
              )
            ) {
              // 其他情况重置
              this.searchInfo.order_type = [];
              setTimeout(() => {
                this.searchInfo.order_type = this.cache.type1;
              }, 0);
            }
          }
        }
        this.searchInfo.payment_type = 1;
        this.searchInfo.refund_status = -1;
        this.searchInfo.refund_time = null; // 清空退款时间
        this.searchInfo.repeal_status = -1; // 清空废除状态
        this.searchInfo.sort_field = "handle_time"; // 重置排序条件
      }
      if (v === "refund_time") {
        if (this.searchInfo.order_type.length === 0) {
          // 异步处理，防止出现一闪而过的数据
          this.searchInfo.order_type = [];
          setTimeout(() => {
            this.searchInfo.order_type = this.cache.type1;
          }, 0);
        } else {
          // 当只有转课类型时，
          if (this.searchInfo.order_type.includes(3)) {
            // order_type 长度为 1 或包含 2、5时不做处理
            if (
              !(
                this.searchInfo.order_type.length === 1 ||
                this.searchInfo.order_type.includes(2) ||
                this.searchInfo.order_type.includes(5)
              )
            ) {
              // 其他情况重置
              this.searchInfo.order_type = [];
              setTimeout(() => {
                this.searchInfo.order_type = this.cache.type2;
              }, 0);
            }
          } else {
            if (
              !(
                this.searchInfo.order_type.includes(2) ||
                this.searchInfo.order_type.includes(5)
              )
            ) {
              // 其他情况重置
              this.searchInfo.order_type = [];
              setTimeout(() => {
                this.searchInfo.order_type = this.cache.type2;
              }, 0);
            }
          }
        }
        this.searchInfo.payment_type = 2;
        this.searchInfo.order_status = -1;
        this.searchInfo.handle_time = null; // 清空支付时间
        this.searchInfo.repeal_status = -1; // 清空废除状态
        this.searchInfo.sort_field = "refund_time"; // 重置排序条件
      }
      // 订单状态
      if (v === "orderStatus") {
        if (this.searchInfo.order_status > 0) {
          this.searchInfo.payment_type = 1; // 收支类型
          this.searchInfo.refund_time = null; // 清空退款时间
          this.searchInfo.repeal_status = -1; // 清空废除状态
          this.searchInfo.refund_status = -1;
          // 订单状态，只有已付款的订单才同时包含购课、购活动
          if (this.searchInfo.order_type.length === 0) {
            // 异步处理，防止出现一闪而过的数据
            this.searchInfo.order_type = [];
            setTimeout(() => {
              this.searchInfo.order_type = this.cache.type1;
            }, 0);
          } else {
            // 当只有转课类型时，
            if (this.searchInfo.order_type.includes(3)) {
              // order_type 长度为 1 或包含 1、4时不做处理
              if (
                !(
                  this.searchInfo.order_type.length === 1 ||
                  this.searchInfo.order_type.includes(1) ||
                  this.searchInfo.order_type.includes(4)
                )
              ) {
                // 其他情况重置
                this.searchInfo.order_type = [];
                setTimeout(() => {
                  this.searchInfo.order_type = this.cache.type1;
                }, 0);
              }
            } else {
              if (
                !(
                  this.searchInfo.order_type.includes(1) ||
                  this.searchInfo.order_type.includes(4)
                )
              ) {
                // 其他情况重置
                this.searchInfo.order_type = [];
                setTimeout(() => {
                  this.searchInfo.order_type = this.cache.type1;
                }, 0);
              }
            }
          }
        } else {
          this.searchInfo.handle_time = null; // 清空支付时间
          this.searchInfo.refund_time = null; // 清空退款时间
          this.searchInfo.order_type = []; // 业务类型
          this.searchInfo.payment_type = -1; // 收支类型
        }
      }
      // 创建时间（最多查询一年的数据）
      if (v === "create_date") {
        let yearTimestamp = 366 * 24 * 60 * 60 * 1000; // 一年的时间戳，需要再多一天（精准）
        let startDate = new Date(this.searchInfo.create_date[0]).getTime();
        let endDate = new Date(this.searchInfo.create_date[1]).getTime();
        if (endDate - startDate > yearTimestamp) {
          this.$message({
            message: "最多查询一年的数据",
            type: "error",
          });
          return false;
        }
      }
      setTimeout(() => {
        this.getList({
          page: 1,
          page_size: this.pageSize,
        });
        this.getOrderTatistics();
      }, 0);
    },
    clickSort(e) {
      if (e.prop === "create_time") {
        let sort = "desc";
        if (e.order == "descending") {
          sort = "desc";
        } else if (e.order == "ascending") {
          sort = "asc";
        }
        this.searchInfo.sort_type = sort;
        this.searchInfo.sort_field = e.prop;
        this.getList({
          page: this.page,
          page_size: this.pageSize,
        });
        PageModule.SET_PAGE_INFO({
          name: "orderManage",
          key: "sort_type",
          value: sort,
        });
      } else if (e.prop === "handle_time") {
        let sort = "desc";
        if (e.order == "descending") {
          sort = "desc";
        } else if (e.order == "ascending") {
          sort = "asc";
        }
        this.searchInfo.sort_type = sort;
        this.searchInfo.sort_field = e.prop;
        this.searchInfo.payment_type = 1;
        this.searchInfo.refund_status = -1;
        this.searchInfo.order_status = 3;
        this.searchInfo.refund_time = null; // 清空退款时间
        // 异步处理，防止出现一闪而过的数据
        this.searchInfo.order_type = [];
        setTimeout(() => {
          this.searchInfo.order_type = this.cache.type1;
          this.getList({
            page: this.page,
            page_size: this.pageSize,
          });
        }, 0);
        PageModule.SET_PAGE_INFO({
          name: "orderManage",
          key: "sort_type",
          value: sort,
        });
      } else if (e.prop === "refund_time") {
        let sort = "desc";
        if (e.order == "descending") {
          sort = "desc";
        } else if (e.order == "ascending") {
          sort = "asc";
        }
        this.searchInfo.sort_type = sort;
        this.searchInfo.sort_field = "handle_time";
        this.searchInfo.payment_type = 2;
        this.searchInfo.order_status = -1;
        this.searchInfo.refund_status = 3;
        this.searchInfo.handle_time = null; // 清空支付时间
        // this.searchInfo.order_type = [2];
        // 异步处理，防止出现一闪而过的数据
        this.searchInfo.order_type = [];
        setTimeout(() => {
          this.searchInfo.order_type = this.cache.type2;
          this.getList({
            page: this.page,
            page_size: this.pageSize,
          });
        }, 0);
        PageModule.SET_PAGE_INFO({
          name: "orderManage",
          key: "sort_type",
          value: sort,
        });
      }
    },
    // 审批状态
    handleApprovalStatus(evt) {
      if (evt.order_type === 1) {
        switch (evt.approval_status) {
          case 0:
            return "无审批";
          case 1:
            return "审批中";
          case 2:
            return "已同意";
          case 3:
            return "已拒绝";
          case 4:
            return "已取消";
        }
      }
      if (evt.order_type === 2 || evt.order_type === 5) {
        if (evt.status === 4 && evt.payment_status === 1) {
          return "已取消";
        } else {
          switch (evt.approval_status) {
            case 0:
              return "无审批";
            case 1:
              return "审批中";
            case 2:
              return "已同意";
            case 3:
              return "已拒绝";
            case 4:
              return "已取消";
          }
        }
      }
      if (evt.order_type === 3) {
        switch (evt.approval_status) {
          case 0:
            return "无审批";
          case 1:
            return "审批中";
          case 2:
            return "已同意";
          case 3:
            return "已拒绝";
          case 4:
            return "已取消";
        }
      }
      if (evt.order_type === 4) {
        switch (evt.approval_status) {
          case 0:
            return "无审批";
          case 1:
            return "审批中";
          case 2:
            return "已同意";
          case 3:
            return "已拒绝";
          case 4:
            return "已取消";
        }
      }
    },
    // 处理订单状态
    handleOrderStatus(evt) {
      let type = evt.payment_type;
      if (evt.order_type === 3) {
        // 转课处理，根据原订单支付类型判断，订单明细使用 order_payment_type
        type = evt.order_payment_type;
      }
      if (type === 1) {
        switch (evt.status) {
          case 1:
            return "待付款";
          case 2:
            return "已付款";
          case 4:
            return "已取消";
          case 5:
            return "部分付款";
        }
      }
      // 订单状态不展示退款状态
      if (type === 2) {
        return "-";
      }
      return "-";
    },
    cachePageInfo() {
      PageModule.SET_PAGE_INFO({
        name: "financialOrderLine",
        key: "search_info",
        value: this.searchInfo,
      });
      PageModule.SET_PAGE_INFO({
        name: "financialOrderLine",
        key: "page",
        value: this.page,
      });
      PageModule.SET_PAGE_INFO({
        name: "financialOrderLine",
        key: "page_size",
        value: this.pageSize,
      });
    },
    toDetail(id) {
      this.cachePageInfo();
      this.$router.push({
        name: "orderManageDetail",
        query: {
          id: String(id),
        },
      });
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
      this.cachePageInfo();
    },
    handlePagerSizeChange(e) {
      this.cachePageInfo();
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  overflow: hidden;
}
.top-title {
  border-bottom: 2px solid #e7e8ea;
  margin-bottom: 16px;
  .text {
    line-height: 43px;
    display: inline-block;
    font-size: 14px;
    color: #07d1aa;
    position: relative;
    padding: 0 12px;
    &:after {
      content: "";
      position: absolute;
      left: 22px;
      right: 22px;
      bottom: -1px;
      border-top: 2px solid #07d1aa;
    }
  }
}
.head-btns {
  margin-bottom: 12px;
}
.ordernum {
  cursor: pointer;
}
.orderAmountBox {
  display: flex;
  .orderAmount {
    display: flex;
    align-items: center;
    background: #fff7e9;
    padding: 10px 10px;
    margin-bottom: 10px;
    border-radius: 4px;
    .question {
      width: 15px;
      height: 15px;
      opacity: 1;
      background: #bebfc0;
      border-radius: 50%;
      color: #fff;
      text-align: center;
      line-height: 16px;
      font-size: 10px;
      margin-left: 5px;
    }
  }
}
.dot {
  &::after {
    content: "、";
  }
  &:last-child {
    &::after {
      display: none;
    }
  }
}
.moneyType {
  padding: 4px;
  font-size: 12px;
  color: #fff;
  background: #07d1aa;
  border-radius: 4px;
}
.retreat {
  background: #f56c6c;
}
.gray {
  color: #5c5d5e;
}
.green {
  color: #07d1aa;
}
.red {
  color: #f56c6c;
}
.origin {
  color: #ffb940;
}
/deep/.form {
  .el-form-item {
    display: flex;
    .el-form-item__label {
      min-width: 80px !important;
      text-align: right;
    }
    .el-form-item__content {
      width: 100%;
    }
  }
}

/deep/.item6,
/deep/.item7 {
  .el-form-item__label {
    width: 69.34px;
    text-align: right !important;
  }
}
/deep/.price-box {
  display: flex;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  input {
    border: 0 !important;
    height: 28px !important;
    line-height: 28px !important;
  }
}
</style>
